// React&NextJS
import { useState } from 'react'
// 3rd party libraries
import uuid from 'react-uuid'
// Styles
import s from './MemoryShare.module.scss'
// Components
import { Memory } from '../../../types/types'
import { Input } from '../../core/input/Input'
import NewShareModal from '../modals/NewShareModal'
import memoryHelperFunctions from '../../../utils/memoryHelperFunctions'

type Props = {
    memory: Memory
    shareCards: any
    openModal: boolean
    setOpenModal: Function
}

export const MemoryShare = ({
    memory,
    shareCards,
    openModal,
    setOpenModal,
}: Props) => {
    // Share cards
    const [email, setEmail] = useState({
        subject: `Minningarsíða - ${memory.fullName}`,
        body: `Minningarsíða - ${memory.fullName}`,
    })
    const shareID = uuid().substring(0, 4)
    const [link, setLink] = useState<string>(
        `https://minningar.is/memories/${memory.mid}?shareID=${shareID}`
    )
    const [shareCard, setShareCard] = useState(memory.shareCards.memory)
    const funeralText = memory?.announcements.funeral?.text ?? ''
    const announcementText = memory?.announcements.deceased?.text ?? ''
    const greetingText = memory?.announcements.greeting?.text ?? ''
    // check funeral status
    const funeralStatus = !memoryHelperFunctions.checkIfFuneralFinished(
        new Date(),
        memory
    )

    const closeModal = () => {
        setShareCard(memory.shareCards.memory)
        setOpenModal(false)
        setLink(
            `https://minningar.is/memories/${memory.mid}?shareID=${shareID}`
        )
    }

    return (
        <NewShareModal
            isOpen={openModal}
            title="Viltu deila?"
            info="Hér getur þú deilt minningarsíðu ásamt tilkynningum á samfélagsmiðlum."
            memory={memory}
            isLoading={!shareCards?.memory}
            closeModal={() => closeModal()}
            published
            imgURL={shareCard}
            link={link}
            email={email}
        >
            {/* radio buttons */}
            {funeralStatus && memory && (
                <>
                    <div className={s.radioBtns}>
                        <Input
                            checked={shareCard === memory.shareCards.memory}
                            type="radio"
                            name="funeral"
                            value={`https://minningar.is/memories/${memory.mid}?shareID=${shareID}`}
                            label="Deila minningarsíðu"
                            onChange={(e) => {
                                setLink(e.target.value)
                            }}
                            onClick={() => {
                                setShareCard(memory.shareCards.memory)
                                setEmail({
                                    subject: `Minningarsíða - ${memory.fullName}`,
                                    body: `Minningarsíða - ${memory.fullName}`,
                                })
                            }}
                        />
                        {announcementText !== '' && (
                            <Input
                                type="radio"
                                name="funeral"
                                value={`https://minningar.is/memories/${memory.mid}?shared=announcement&shareID=${shareID}`}
                                label="Deila andlátstilkynningu"
                                onChange={(e) => setLink(e.target.value)}
                                onClick={() => {
                                    setShareCard(memory.shareCards.deceased)
                                    setEmail({
                                        subject: `Andlátstilkynning - ${memory.fullName}`,
                                        body: announcementText,
                                    })
                                }}
                            />
                        )}
                        {funeralText !== '' && (
                            <Input
                                type="radio"
                                name="funeral"
                                value={`https://minningar.is/memories/${memory.mid}?shared=funeral&shareID=${shareID}`}
                                label="Deila útfarartilkynningu"
                                onChange={(e) => setLink(e.target.value)}
                                onClick={() => {
                                    setShareCard(memory.shareCards.funeral)
                                    setEmail({
                                        subject: `Útfarartilkynning - ${memory.fullName}`,
                                        body: funeralText,
                                    })
                                }}
                            />
                        )}
                        {greetingText !== '' && (
                            <Input
                                type="radio"
                                name="funeral"
                                value={`https://minningar.is/memories/${memory.mid}?shared=greeting&shareID=${shareID}`}
                                label="Deila þakkartilkynningu"
                                onChange={(e) => setLink(e.target.value)}
                                onClick={() => {
                                    setShareCard(memory.shareCards.greeting)
                                    setEmail({
                                        subject: `Þakkir - ${memory.fullName}`,
                                        body: greetingText,
                                    })
                                }}
                            />
                        )}
                    </div>
                </>
            )}
        </NewShareModal>
    )
}
